module.exports = __webpack_public_path__ + "static/media/kingsarcade2.e1cad1e8.jpg";